/**
 * This file specifies the state of the application in response to Vendor Bill actions
 */
import { fromJS } from 'immutable';
import Constants from '../../constants';

const { VendorBills, VendorBill } = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  vendorBills: [],
  vendorBill: {},
  count: 0,
});

/**
 * Returns and sets the next state based on the action passed to it
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const vendorBillsReducer = (state = initialState, action) => {
  const { count, error, vendorBills, vendorBill } = action;

  switch (action.type) {
    case VendorBills.GET_VENDOR_BILLS:
      return state.set('loading', true);
    case VendorBills.GET_VENDOR_BILLS_ERROR:
      return state.set('loading', false).set('error', error);
    case VendorBills.GET_VENDOR_BILLS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('vendorBills', fromJS(vendorBills))
        .set('count', count);
    case VendorBill.GET_VENDOR_BILL:
      return state.set('loading', true);
    case VendorBill.GET_VENDOR_BILL_ERROR:
      return state.set('loading', false).set('error', error);
    case VendorBill.GET_VENDOR_BILL_SUCCESS:
      return state.set('loading', false).set('vendorBill', fromJS(vendorBill));
    default:
      return state;
  }
};

export default vendorBillsReducer;
